/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

/* eslint-disable no-restricted-syntax --
 * These re-exports are only of constants, only two-levels deep, and
 * should not cause problems for tree-shakers.
 */

// Deprecated. These are kept around for compatibility purposes
export * from './trace';
export * from './resource';

// Use these instead
export * from './stable_attributes';
export * from './stable_metrics';
export * from './stable_events';
